import { __decorate } from "tslib";
import { Action, Getter, Mutation, State } from "@/types";
import { service } from "@/services";
export class GuestPassesModule {
    constructor() {
        this.guestPasses = [];
        this.count = 0;
        this.axiosError = null;
    }
    setGuestPasses(guestPasses) {
        this.guestPasses = guestPasses;
    }
    setTotal(count) {
        this.count = count;
    }
    setError(error) {
        this.axiosError = error;
    }
    get list() {
        return this.guestPasses;
    }
    get total() {
        return this.count;
    }
    get errorList() {
        return this.axiosError;
    }
    async get(options) {
        try {
            const data = await service.guestPasses.get(options);
            this.setGuestPasses(data.items);
            this.setTotal(data.total);
        }
        catch (error) {
            this.setError(error);
            // push into Notice
            // server text error - "error.response.data.message"
            // or default error - "error.response.statusText"
            // or custom error message
            // or return Promise.reject(error)
        }
    }
    async add(guestPasses) {
        try {
            await service.guestPasses.add(guestPasses);
            return true;
        }
        catch (error) {
            this.setError(error);
            return false;
        }
    }
    async edit(guestPasses) {
        try {
            await service.guestPasses.edit(guestPasses);
            return true;
        }
        catch (error) {
            this.setError(error);
            return false;
            // push into Notice
            // server text error - "error.response.data.message"
            // or default error - "error.response.statusText"
            // or custom error message
            // or return Promise.reject(error)
        }
    }
    async delete(guestPassesId) {
        try {
            await service.guestPasses.delete(guestPassesId);
            return true;
        }
        catch (error) {
            this.setError(error);
            return false;
            // push into Notice
            // server text error - "error.response.data.message"
            // or default error - "error.response.statusText"
            // or custom error message
            // or return Promise.reject(error)
        }
    }
}
__decorate([
    State()
], GuestPassesModule.prototype, "guestPasses", void 0);
__decorate([
    State()
], GuestPassesModule.prototype, "count", void 0);
__decorate([
    State()
], GuestPassesModule.prototype, "axiosError", void 0);
__decorate([
    Mutation()
], GuestPassesModule.prototype, "setGuestPasses", null);
__decorate([
    Mutation()
], GuestPassesModule.prototype, "setTotal", null);
__decorate([
    Mutation()
], GuestPassesModule.prototype, "setError", null);
__decorate([
    Getter()
], GuestPassesModule.prototype, "list", null);
__decorate([
    Getter()
], GuestPassesModule.prototype, "total", null);
__decorate([
    Getter()
], GuestPassesModule.prototype, "errorList", null);
__decorate([
    Action()
], GuestPassesModule.prototype, "get", null);
__decorate([
    Action()
], GuestPassesModule.prototype, "add", null);
__decorate([
    Action()
], GuestPassesModule.prototype, "edit", null);
__decorate([
    Action()
], GuestPassesModule.prototype, "delete", null);
